module.exports = __webpack_public_path__ + "static/media/6.059911bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/6.jpg
// module id = 1001
// module chunks = 0